/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */

import { PayloadAction } from 'typesafe-actions';

import { AnalyticsAction, AnalyticsService } from '@investown/fe/common-utils';

// Type definition for the Bloomreach Javascript SDK
export interface ExponeaWebType {
  start(): void;
  identify: (
    customerIds: Record<string, string>,
    customerProperties?: Record<string, any>,
    successCallback?: void,
    errorCallback?: void,
    immediate?: void
  ) => void;
  track: (
    eventName: string,
    eventProperties?: Record<string, any>,
    successCallback?: (status?: Record<string, any>) => void,
    errorCallback?: (error: any) => void
  ) => void;
  getSegments: (
    exposingCategory: string,
    successCallback: () => { segmentsDefinition: Record<string, any>[] },
    errorCallback: () => void,
    options?: { force: boolean }
  ) => void;
  update: (customerAttributes: Record<string, any>) => void;
  showHtml: (cssSelector: string, htmlNodeName: string) => void;
  getHtml: (htmlNodeName: string, callback: () => void) => void;
  // @deprecated, use showWebLayer
  showBanner: (bannerId: string, parameters?: Record<string, any>) => void;
  showWebLayer: (
    bannerId: string,
    parameters?: Record<string, any>,
    noHiding?: boolean,
    onSuccess?: () => void
  ) => void;
  ping: (enabled?: boolean, interval?: number, activity?: boolean, properties?: Record<string, any>) => void;
  getAbTest: (testName: string, variants: Record<string, any>, callback?: () => void) => void;
  loadDependency: (dependencies?: Record<string, any>) => void;
  getRecommendation: (options: {
    recommendationId: string;
    callback: () => void;
    fillWithRandom?: boolean;
    size?: number;
    items?: Record<string, any>;
    catalogFilter?: Record<string, any>[];
    catalogAttributesWhitelist?: string[];
    strategy?: string;
    categoryNames?: string[];
  }) => void;
  reloadWebLayers: (callback?: () => void) => void;
  _preInitialize: (config: Record<string, any>) => void;
  _initializeConfig: (config: Record<string, any>) => void;
  [key: string]: any; // Allows for dynamic addition of methods
}
const exponea = (window as any).exponea as ExponeaWebType;

export const createBloomreachWebAnalyticsService = (): AnalyticsService => {
  return {
    init: () => {
      exponea.start();
    },
    trackScreenView: (payload): void => {
      exponea.track(
        'screen_view',
        {
          path: payload.path,
        },
        () => null,
        (error) => {
          console.error(`Error tracking event screen_view`, error);
        }
      );
    },
    trackEvent: (action): void => {
      switch (action.type) {
        case AnalyticsAction.ERROR: {
          // TODO: Implement payload and event call for web Bloomreach
          break;
        }
        case AnalyticsAction.LOGIN: {
          // TODO: Implement payload and event call for web Bloomreach
          break;
        }
        case AnalyticsAction.INVEST: {
          // TODO: Implement payload and event call for web Bloomreach
          break;
        }
        case AnalyticsAction.INVEST_OVERVIEW: {
          // TODO: Implement payload and event call for web Bloomreach
          break;
        }
        case AnalyticsAction.REGISTRATION_STEP: {
          // TODO: Implement payload and event call for web Bloomreach
          break;
        }
        case AnalyticsAction.INVITE_FRIENDS: {
          // TODO: Implement payload and event call for web Bloomreach
          break;
        }
        case AnalyticsAction.VIEW_ITEM: {
          // TODO: Implement payload and event call for web Bloomreach
          break;
        }
        default:
          exponea.track(
            action.type,
            (action as PayloadAction<string, any>).payload || {},
            () => null,
            (error) => {
              console.error(`Error tracking event ${action.type}`, error);
            }
          );
      }
    },
  };
};
